import React, { useState, useEffect } from 'react';
import { Container, Card, Row, Col, Button, Tabs, Tab } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { FaPlus } from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';
import FormDadosGerais from './FormDadosGerais';
import FormConfigVendas from './FormConfigVendas';
import GridUsuariosFase from './GridUsuariosFase';
import GridParceiros from './GridParceiros';
import TabComissoes from './TabComissoes';
import TabProjeto from './TabProjeto';
import TabContabil from './TabContabil';
import TabIntegracao from './TabIntegracao';
import TabCartoes from './TabCartoes';

const EmpreendimentoConfig = () => {
  const [familias, setFamilias] = useState([]);
  const [gruposEmpreendimento, setGruposEmpreendimento] = useState([]);
  const [familiaSelecionada, setFamiliaSelecionada] = useState(null);
  const [dadosGerais, setDadosGerais] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tabAtiva, setTabAtiva] = useState('dados-gerais');
  const [permissoes, setPermissoes] = useState({});
  const [dadosComissoes, setDadosComissoes] = useState(null);
  const [dadosComFixa, setDadosComFixa] = useState(null);
  const [dadosProjeto, setDadosProjeto] = useState(null);
  const [dadosContabil, setDadosContabil] = useState(null);
  const [dadosIntegracao, setDadosIntegracao] = useState(null);

  useEffect(() => {
    carregarFamilias();
    carregarGruposEmpreendimento();
    carregarPermissoes();
  }, []);

  useEffect(() => {
    if (familiaSelecionada != null) {
      setDadosGerais(null);
      setDadosComissoes(null);
      setDadosComFixa(null);
      setDadosProjeto(null);
      setDadosContabil(null);
      setDadosIntegracao(null);
      setTabAtiva('dados-gerais');
      carregarDadosGerais(familiaSelecionada.value);
      carregarIntegracao(familiaSelecionada.value);
    } else {
      setDadosGerais(null);
    }
  }, [familiaSelecionada]);

  useEffect(() => {
    if (familiaSelecionada == null) return;
    const cod = familiaSelecionada.value;
    if (tabAtiva === 'comissoes' && dadosComissoes == null) {
      carregarComissoes(cod);
      carregarComFixa(cod);
    }
    if (tabAtiva === 'projeto' && dadosProjeto == null) {
      carregarProjeto(cod);
    }
    if (tabAtiva === 'contabil' && dadosContabil == null) {
      carregarContabil(cod);
    }
    if (tabAtiva === 'integracao' && dadosIntegracao == null) {
      carregarIntegracao(cod);
    }
  }, [tabAtiva, familiaSelecionada]);

  const carregarFamilias = async () => {
    try {
      const res = await api.listarFamiliasConfig();
      const opts = (res || []).map((f) => ({
        value: f.codigo_familia,
        label: f.nome_da_familia,
      }));
      setFamilias(opts);
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao carregar empreendimentos';
      toast.error(msg);
    }
  };

  const carregarGruposEmpreendimento = async () => {
    try {
      const res = await api.listarGruposGELookup();
      const lista = res && res.data ? res.data : (res || []);
      const opts = (Array.isArray(lista) ? lista : []).map((g) => ({
        value: g.codigo,
        label: g.descricao,
      }));
      setGruposEmpreendimento(opts);
    } catch (err) {
      // silencioso — campo opcional
    }
  };

  const carregarPermissoes = async () => {
    try {
      const res = await api.buscarPermissoesEmpreendimento();
      setPermissoes(res && res.data ? res.data : (res || {}));
    } catch (err) {
      // permissões silenciosas — tela carrega sem bloquear
    }
  };

  const carregarDadosGerais = async (cod) => {
    setLoading(true);
    try {
      const res = await api.buscarEmpreendimentoConfig(cod);
      setDadosGerais(res && res.data ? res.data : (res || null));
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao carregar configuração';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const carregarComissoes = async (cod) => {
    try {
      const res = await api.buscarComissoesConfig(cod);
      setDadosComissoes(res && res.data ? res.data : (res || null));
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao carregar comissões';
      toast.error(msg);
    }
  };

  const carregarComFixa = async (cod) => {
    try {
      const res = await api.buscarComFixaConfig(cod);
      setDadosComFixa(res && res.data ? res.data : (res || null));
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao carregar comissão fixa';
      toast.error(msg);
    }
  };

  const carregarProjeto = async (cod) => {
    try {
      const res = await api.buscarProjetoConfig(cod);
      setDadosProjeto(res && res.data ? res.data : (res || null));
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao carregar projeto';
      toast.error(msg);
    }
  };

  const carregarContabil = async (cod) => {
    try {
      const res = await api.buscarContabilConfig(cod);
      setDadosContabil(res && res.data ? res.data : (res || null));
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao carregar dados contábeis';
      toast.error(msg);
    }
  };

  const carregarIntegracao = async (cod) => {
    try {
      const res = await api.buscarIntegracaoConfig(cod);
      setDadosIntegracao(res && res.data ? res.data : (res || null));
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao carregar integração';
      toast.error(msg);
    }
  };

  const handleIncluir = () => {
    if (!familiaSelecionada) {
      toast.info('Selecione um empreendimento para incluir as configurações iniciais.');
      return;
    }
    if (!window.confirm('Deseja criar a configuração inicial para este empreendimento?')) return;
    api
      .incluirEmpreendimento({ codigo_familia: familiaSelecionada.value })
      .then(() => {
        toast.success('Configuração criada com sucesso!');
        carregarDadosGerais(familiaSelecionada.value);
      })
      .catch((err) => {
        const msg = err && err.message ? err.message : 'Erro ao incluir empreendimento';
        toast.error(msg);
      });
  };

  const handleSalvarDadosGerais = async (dados) => {
    try {
      await api.salvarDadosGerais(dados);
      toast.success('Dados gerais salvos com sucesso!');
      carregarDadosGerais(familiaSelecionada.value);
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao salvar dados gerais';
      toast.error(msg);
    }
  };

  const handleSalvarConfigVendas = async (dados) => {
    try {
      await api.salvarConfigVendas(dados);
      toast.success('Config. de vendas salva com sucesso!');
      carregarDadosGerais(familiaSelecionada.value);
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao salvar configuração de vendas';
      toast.error(msg);
    }
  };

  const handleSalvarProjeto = async (dados) => {
    try {
      await api.salvarProjetoConfig(dados);
      toast.success('Projeto salvo com sucesso!');
      carregarProjeto(familiaSelecionada.value);
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao salvar projeto';
      toast.error(msg);
    }
  };

  return (
    <Container fluid className="px-3 py-3">
      <Header title="Empreendimento" />

      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-center">
            <Col md={5}>
              <Select
                options={familias}
                value={familiaSelecionada}
                onChange={setFamiliaSelecionada}
                placeholder="Selecione o empreendimento..."
                styles={customStyles}
                components={{ DropdownIndicator }}
                isClearable
              />
            </Col>
            <Col md={7} className="text-right">
              <Button
                variant="outline-primary"
                size="sm"
                onClick={handleIncluir}
                disabled={familiaSelecionada == null}
              >
                <FaPlus className="mr-1" /> Incluir Config.
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {loading && <Loading />}

      {familiaSelecionada != null && dadosGerais != null && !loading && (
        <Card className="shadow-sm">
          <Card.Header
            style={{ backgroundColor: '#0747a6', color: '#fff', fontWeight: 600 }}
          >
            Configuração do Empreendimento — {familiaSelecionada.label}
          </Card.Header>
          <Card.Body className="p-0">
            <Tabs activeKey={tabAtiva} onSelect={setTabAtiva} className="px-3 pt-2">
              <Tab eventKey="dados-gerais" title="Dados Gerais">
                <div className="p-3">
                  <FormDadosGerais
                    dados={dadosGerais}
                    permissoes={permissoes}
                    familias={familias}
                    gruposEmpreendimento={gruposEmpreendimento}
                    razaoSocial={dadosIntegracao != null && dadosIntegracao.razao_social != null ? dadosIntegracao.razao_social : []}
                    codigoFamilia={familiaSelecionada.value}
                    onSalvar={handleSalvarDadosGerais}
                    onRecarregar={() => carregarDadosGerais(familiaSelecionada.value)}
                  />
                  <GridParceiros
                    codigoFamilia={familiaSelecionada.value}
                    codigoGrupoEmpresa={dadosGerais != null ? dadosGerais.codigo_grupo_empresa : null}
                    permissoes={permissoes}
                  />
                </div>
              </Tab>
              <Tab eventKey="config-vendas" title="Config. Vendas">
                <div className="p-3">
                  <FormConfigVendas
                    dados={dadosGerais}
                    permissoes={permissoes}
                    onSalvar={handleSalvarConfigVendas}
                  />
                  <GridUsuariosFase
                    codigoFamilia={familiaSelecionada.value}
                    familias={familias}
                    permissoes={permissoes}
                  />
                </div>
              </Tab>
              <Tab eventKey="comissoes" title="Comissões">
                <div className="p-3">
                  <TabComissoes
                    codigoFamilia={familiaSelecionada.value}
                    dados={dadosComissoes}
                    dadosGerais={dadosGerais}
                    comFixa={dadosComFixa}
                    familias={familias}
                    permissoes={permissoes}
                    onRecarregar={() => {
                      carregarComissoes(familiaSelecionada.value);
                      carregarComFixa(familiaSelecionada.value);
                    }}
                  />
                </div>
              </Tab>
              <Tab eventKey="projeto" title="Projeto">
                <div className="p-3">
                  <TabProjeto
                    codigoFamilia={familiaSelecionada.value}
                    dados={dadosProjeto}
                    dadosGerais={dadosGerais}
                    permissoes={permissoes}
                    onSalvar={handleSalvarProjeto}
                    onRecarregar={() => carregarProjeto(familiaSelecionada.value)}
                  />
                </div>
              </Tab>
              <Tab eventKey="contabil" title="Contábil">
                <div className="p-3">
                  <TabContabil
                    codigoFamilia={familiaSelecionada.value}
                    dados={dadosContabil}
                    permissoes={permissoes}
                    onRecarregar={() => carregarContabil(familiaSelecionada.value)}
                  />
                </div>
              </Tab>
              <Tab eventKey="integracao" title="Integração">
                <div className="p-3">
                  <TabIntegracao
                    codigoFamilia={familiaSelecionada.value}
                    dados={dadosIntegracao}
                    permissoes={permissoes}
                    onRecarregar={() => carregarIntegracao(familiaSelecionada.value)}
                  />
                </div>
              </Tab>
              <Tab eventKey="cartoes" title="Cartões" mountOnEnter>
                <div className="p-3">
                  <TabCartoes
                    codigoFamilia={familiaSelecionada.value}
                  />
                </div>
              </Tab>
            </Tabs>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default EmpreendimentoConfig;
